(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wrapKanjiInPortes() {
    document.querySelectorAll('[data-section-name="text-columns-with-images"] .text-columns-img__heading').forEach(function (heading) {
      var target = heading.querySelector('a') || heading;
      if (target.dataset.bnexoKanji) {
        return;
      }
      var text = target.textContent;
      if (!text || text.indexOf('//') === -1 || text.indexOf('予') === -1) {
        return;
      }
      var parts = text.split('//');
      if (parts.length < 2) {
        return;
      }
      target.innerHTML =
        '<span class="bnexo-kanji-live">' + parts[0].trim() + '</span>' +
        ' <span class="bnexo-porte-sep">//</span> ' +
        '<span class="bnexo-porte-label">' + parts.slice(1).join('//').trim() + '</span>';
      target.dataset.bnexoKanji = '1';
    });
  }

  function initHeroGlitch() {
    if (reducedMotion) {
      return;
    }
    document.querySelectorAll('.slideshow__heading').forEach(function (heading) {
      if (heading.dataset.bnexoGlitch) {
        return;
      }
      heading.dataset.bnexoGlitch = '1';
      heading.classList.add('bnexo-glitch-once');
      window.setTimeout(function () {
        heading.classList.remove('bnexo-glitch-once');
      }, 900);
    });
  }

  function initTickerPop() {
    document.querySelectorAll('[data-section-name="ticker"] .ticker__item strong').forEach(function (el) {
      el.classList.add('bnexo-ticker-glow');
    });
  }

  function initCountdownFlash() {
    if (reducedMotion) {
      return;
    }
    document.querySelectorAll('.bnexo-drop-countdown .h1, .image-with-text__countdown .h1').forEach(function (el) {
      if (el.dataset.bnexoFlash) {
        return;
      }
      el.dataset.bnexoFlash = '1';
      var last = el.textContent;
      window.setInterval(function () {
        if (el.textContent !== last) {
          last = el.textContent;
          el.classList.remove('bnexo-countdown-flash');
          void el.offsetWidth;
          el.classList.add('bnexo-countdown-flash');
        }
      }, 200);
    });
  }

  function initBadgeMadness() {
    document.querySelectorAll('.bnexo-glass-badge--chase, .bnexo-badge--chase').forEach(function (b) {
      b.classList.add('bnexo-badge--wild');
    });
    document.querySelectorAll('.bnexo-glass-badge--limited, .bnexo-badge--limited').forEach(function (b) {
      b.classList.add('bnexo-badge--wild');
    });
  }

  function initHeroSpark() {
    if (reducedMotion) {
      return;
    }
    var slideshow = document.querySelector('[data-section-name="slideshow"], .slideshow');
    if (!slideshow || slideshow.dataset.bnexoSpark) {
      return;
    }
    slideshow.dataset.bnexoSpark = '1';
    slideshow.addEventListener('click', function (e) {
      if (!e.target.closest('.slideshow__text-wrapper, .slideshow__heading, .btn')) {
        return;
      }
      var spark = document.createElement('span');
      spark.className = 'bnexo-spark';
      spark.style.left = e.clientX + 'px';
      spark.style.top = e.clientY + 'px';
      document.body.appendChild(spark);
      window.setTimeout(function () {
        spark.remove();
      }, 700);
    });
  }

  function run() {
    wrapKanjiInPortes();
    initHeroGlitch();
    initTickerPop();
    initCountdownFlash();
    initBadgeMadness();
    initHeroSpark();
  }

  function init() {
    run();
    window.setTimeout(run, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    run();
  });
})();
